import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import Switch from '../../../base/ui/components/web/Switch';
import { toggleLobbyMode } from '../../actions';
// @ts-ignore
import { setPassword } from "../../../base/conference/actions";
// @ts-ignore
import { passwordHash } from '../../functions';
/**
 * Implements a security feature section to control lobby mode.
 */
class LobbySection extends PureComponent {
    /**
     * Instantiates a new component.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            lobbyEnabled: props._lobbyEnabled
        };
        this._onToggleLobby = this._onToggleLobby.bind(this);
    }
    /**
     * Implements React's {@link Component#getDerivedStateFromProps()}.
     *
     * @inheritdoc
     */
    static getDerivedStateFromProps(props, state) {
        if (props._lobbyEnabled !== state.lobbyEnabled) {
            return {
                lobbyEnabled: props._lobbyEnabled
            };
        }
        return null;
    }
    /**
     * Implements {@code PureComponent#render}.
     *
     * @inheritdoc
     */
    render() {
        const { t } = this.props;
        return (React.createElement("div", { id: 'lobby-section' },
            React.createElement("p", { className: 'description', role: 'banner' }, t('lobby.enableDialogText')),
            React.createElement("div", { className: 'control-row' },
                React.createElement("label", { htmlFor: 'lobby-section-switch' }, t('lobby.toggleLabel')),
                React.createElement(Switch, { checked: this.state.lobbyEnabled, id: 'lobby-section-switch', onChange: this._onToggleLobby }))));
    }
    /**
     * Callback to be invoked when the user toggles the lobby feature on or off.
     *
     * @returns {void}
     */
    _onToggleLobby() {
        //console.log("MS -----> DENTRO ONTOGGLELOBBY -------------------- ");
        const newValue = !this.state.lobbyEnabled;
        this.setState({
            lobbyEnabled: newValue
        });
        //const { _conference } = this.props;
        const state = APP.store.getState();
        const { conference, password } = state['features/base/conference'];
        //console.log(conference);
        if (newValue) {
            //console.log("MS -----> controllo la password di stanza e a seconda del valore procedo lasciando quella esistente o risettandola con quella di sistema");
            //console.log(password);
            if (password != null) {
                //console.log("MS -----> non faccio niente perché mantengo quella scelta dal moderatore");
            }
            else {
                //console.log("MS -----> inserisco la password generata dal sistema");
                // @ts-ignore
                this.props.dispatch(setPassword(conference, conference.lock, passwordHash()));
            }
        }
        else {
            //console.log("MS -----> controllo se la password che c\'era settata è quella di sistema o altra");
            var cifrata = passwordHash();
            //console.log("MS -----> stampo a video prima la password: "", password);
            //console.log("MS -----> e poi quella generata dal sistema: "", cifrata);
            if (cifrata == password) {
                //console.log("MS -----> dato che sono identiche, la elimino");
                // @ts-ignore
                this.props.dispatch(setPassword(conference, conference.lock, ""));
            }
            else {
                //console.log("MS -----> sono diverse, quindi lascio quella che il moderatore si era settato");
            }
        }
        //console.log("MS -----> Abilito/disabilito la Lobby ");
        this.props.dispatch(toggleLobbyMode(newValue));
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {IProps}
 */
function mapStateToProps(state) {
    return {
        _lobbyEnabled: state['features/lobby'].lobbyEnabled
    };
}
export default translate(connect(mapStateToProps)(LobbySection));
